<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">

    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">VALET CONTRATTI</a>
      </label>
    </div>

    <section class="main-content wrapper content-padding">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
      <div
        class="custom-data-output has-margin-top"
        role="table"
        id="elencoConsegnePartner"
      >
        <form  class="table-row-container row first-row filter" [formGroup]="serviceFilterForm" (ngSubmit)="filter()" *ngIf="serviceFilterForm">
          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder('ExpertContracts.id')">
              <i class="sort-icon fas" [ngClass]="orderIcon('ExpertContracts.id')"></i>
              ID
            </h4>
            <span class="data">
                <input type="number" formControlName="ExpertContracts.id"> 
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('UserExpert.surname')">
              <i class="sort-icon fas" [ngClass]="orderIcon('UserExpert.surname')"></i>
              VALET
            </h4>
            <span class="data">
                <input type="text" formControlName="UserExpert.surname"> 
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title">
              CONTRATTI GENERATO
            </h4>
            <span class="data">
              
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title">
              CONTRATTI FIRMATO
            </h4>
            <span class="data">
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container btn-container-actions">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i></button>
                <br/>
              <button class="btn vertical align-items-center" (click)="fnReset();">
                RESET <i class="fas fa-times-circle"></i></button>
            </span>
          </div>
        </form>

        <div class="table-row-container row" *ngFor="let contract of contracts">
          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              ID
            </h4>
            <div class="data data-id">
              <div>{{ contract.id }}</div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              VALET
            </h4>
            <div class="data">
              <div>{{contract.expert?.user?.surname}} {{contract.expert?.user?.name}}</div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              CONTRATTI GENERATO
            </h4>
            <div class="data">
              <a *ngIf="contract?.contractUrl"
                (click)="openPdf(contract.contractUrl)"
                class="link">
                Visualizza
              </a>
              <span *ngIf="!contract?.contractUrl">N/A</span>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
                CONTRATTI FIRMATO
            </h4>
            <div class="data">

              <div class="data">
                <a *ngIf="contract?.signedContractUrl"
                  (click)="openPdf(contract.signedContractUrl)"
                  class="link">
                  Visualizza
                </a>
                <span *ngIf="!contract?.signedContractUrl">N/A</span>
              </div>
            </div>
          </div>

          <!--
          <div class="item nowrap">
            <span class="data-row-left btn-container btn-container-actions">
              <button class="btn btn-red vertical align-items-center" >
                Elimina<i class="ml-10 far fa-trash-alt"></i>
              </button>
            </span>
          </div>
          -->
        </div>
      </div>
    </section>
  </div>
</section>

<div class="pdf-modal" *ngIf="pdfUrl" [@fadeIn]>
  <div class="pdf-backdrop" (click)="closePdf()"></div>

  <div class="pdf-container" [@slideUp]>
    <div class="pdf-header">
      <div class="pdf-title">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
        </svg>
        <span>Document Preview</span>
      </div>
      
      <div class="pdf-actions">
        
        <button class="action-btn" (click)="openInNewTab()" title="Open in new tab">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
            <polyline points="15 3 21 3 21 9"/>
            <line x1="10" y1="14" x2="21" y2="3"/>
          </svg>
        </button>
        
        <button class="close-btn" (click)="closePdf()" title="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="pdf-viewer">
      <embed
        [src]="pdfUrl"
        type="application/pdf"
        width="100%"
        height="100%"
      />
      
      <div class="pdf-fallback" *ngIf="showFallback">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
        </svg>
        <h3>Unable to display PDF</h3>
        <p>Your browser doesn't support inline PDF viewing</p>
        <button class="primary-btn" (click)="downloadPdf()">
          Download PDF
        </button>
        <button class="secondary-btn" (click)="openInNewTab()">
          Open in New Tab
        </button>
      </div>
    </div>
  </div>
</div>